/**
 * @generated SignedSource<<32d7d89635186a239a8faeb4305d4c52>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CustomColor = "A" | "B" | "C" | "D" | "E" | "F";
import { FragmentRefs } from "relay-runtime";
export type EventDetailHeader$data = {
  readonly eventSeries: {
    readonly color: CustomColor;
    readonly facility: {
      readonly club: {
        readonly slug: string;
      } | null | undefined;
      readonly name: string;
    };
    readonly name: string;
  };
  readonly id: string;
  readonly " $fragmentType": "EventDetailHeader";
};
export type EventDetailHeader$key = {
  readonly " $data"?: EventDetailHeader$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventDetailHeader">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventDetailHeader",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventSeries",
      "kind": "LinkedField",
      "name": "eventSeries",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Facility",
          "kind": "LinkedField",
          "name": "facility",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "slug",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "5a3b02b65136c0842d6f5466468cba64";

export default node;
